import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Card, CardContent, CircularProgress, Typography, Button,
} from '@material-ui/core';
import _ from 'lodash';

import {
  getCandidateGDFormConfig,
  updateCandidateGDInfo,
} from '../../../services/groupDiscussionDetailServices';
import FormBuilder from '../../../components/FormBuilder';

class CandidateGDCard extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    onSuccess: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    setLoading: PropTypes.func.isRequired,
    formErrorMessages: PropTypes.object,
    clearFormErrorForField: PropTypes.func,
  };

  static defaultProps = {
    formErrorMessages: {},
    clearFormErrorForField: () => {},
  };

  state = {
    dataLoaded: false,
    candidateGDInfo: {},
    error: null,
  };

  componentDidMount() {
    this.fetchCandidateGDInfo();
  }

  fetchCandidateGDInfo = () => {
    getCandidateGDFormConfig(
      this.props.id,
      (response) => {
        this.setState({ dataLoaded: true, candidateGDInfo: response });
      },
      (error) => {
        const errorMessage = _.get(error, 'error.response.data.error');
        this.setState({
          dataLoaded: true,
          error: errorMessage || 'something went wrong. please refresh the page',
        });
      },
    );
  };

  submitCandidateInfo = (formData) => {
    const {
      id, onSuccess, onError, setLoading,
    } = this.props;

    setLoading();
    updateCandidateGDInfo(id, formData, onSuccess, onError);
  };

  render() {
    return (
      <Card>
        <CardContent>
          {!this.state.dataLoaded ? (
            <CircularProgress />
          ) : this.state.error ? (
            <Typography variant="subheading" color="error">
              {this.state.error}
            </Typography>
          ) : (
            <FormBuilder
              errors={this.props.formErrorMessages}
              clearErrorForField={this.props.clearFormErrorForField}
              config={this.state.candidateGDInfo}
              renderFormActions={({ validateForm, formData }) => (
                <ButtonContainer>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      if (validateForm(formData)) {
                        this.submitCandidateInfo(formData);
                      } else {
                        const error = {
                          response: {
                            data: {
                              errors: {
                                id: 'please check for error in the candidate form',
                              },
                            },
                          },
                        };
                        this.props.onError(error);
                      }
                    }}
                  >
                    Submit
                  </Button>
                </ButtonContainer>
              )}
            />
          )}
        </CardContent>
      </Card>
    );
  }
}

export default CandidateGDCard;

const ButtonContainer = styled.div`
  text-align: right;
  margin-top: 30px;
`;



// WEBPACK FOOTER //
// ./src/pages/GroupDiscussionDetail/components/CandidateGDCard.js